import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormContainer from '../components/FormContainer';
import CheckoutSteps from '../components/CheckoutSteps';
import { savePaymentMethod } from '../actions/cartActions';

const PaymentScreen = () => {
  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [paymentMethod, setPaymentMethod] = useState('M-Pesa');

  useEffect(() => {
    if (!shippingAddress.address) {
      navigate('/shipping');
    }
  }, [shippingAddress, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(savePaymentMethod(paymentMethod));
    navigate('/placeorder');
  };

  return (
    <>
      <CheckoutSteps step1 step2 step3 />
      <FormContainer>
        <h1 className="text-2xl font-semibold mb-6">Payment Method</h1>
        <form onSubmit={submitHandler}>
          <div className="mb-6">
            <h2 className="text-lg font-medium mb-4">Select Payment Method</h2>
            <div className="space-y-4">
              <div className="flex items-center">
                <input
                  id="mpesa"
                  name="paymentMethod"
                  type="radio"
                  value="M-Pesa"
                  checked={paymentMethod === 'M-Pesa'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  className="h-5 w-5 text-primary border-gray-300 focus:ring-primary"
                />
                <label
                  htmlFor="mpesa"
                  className="ml-3 flex items-center cursor-pointer"
                >
                  <img
                    src="/images/mpesa-logo.png"
                    alt="M-Pesa"
                    className="h-8 mr-2"
                  />
                  <span className="font-medium">M-Pesa</span>
                </label>
              </div>

              <div className="flex items-center">
                <input
                  id="pesapal"
                  name="paymentMethod"
                  type="radio"
                  value="PesaPal"
                  checked={paymentMethod === 'PesaPal'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  className="h-5 w-5 text-primary border-gray-300 focus:ring-primary"
                />
                <label
                  htmlFor="pesapal"
                  className="ml-3 flex items-center cursor-pointer"
                >
                  <img
                    src="/images/pesapal-logo.png"
                    alt="PesaPal"
                    className="h-8 mr-2"
                  />
                  <span className="font-medium">PesaPal</span>
                </label>
              </div>

              <div className="flex items-center">
                <input
                  id="bankTransfer"
                  name="paymentMethod"
                  type="radio"
                  value="Bank Transfer"
                  checked={paymentMethod === 'Bank Transfer'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  className="h-5 w-5 text-primary border-gray-300 focus:ring-primary"
                />
                <label
                  htmlFor="bankTransfer"
                  className="ml-3 flex items-center cursor-pointer"
                >
                  <i className="fas fa-university text-gray-600 text-xl mr-2"></i>
                  <span className="font-medium">Bank Transfer</span>
                </label>
              </div>

              <div className="flex items-center">
                <input
                  id="creditCard"
                  name="paymentMethod"
                  type="radio"
                  value="Credit Card"
                  checked={paymentMethod === 'Credit Card'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  className="h-5 w-5 text-primary border-gray-300 focus:ring-primary"
                />
                <label
                  htmlFor="creditCard"
                  className="ml-3 flex items-center cursor-pointer"
                >
                  <i className="fas fa-credit-card text-gray-600 text-xl mr-2"></i>
                  <span className="font-medium">Credit Card</span>
                </label>
              </div>

              <div className="flex items-center">
                <input
                  id="payOnDelivery"
                  name="paymentMethod"
                  type="radio"
                  value="Pay on Delivery"
                  checked={paymentMethod === 'Pay on Delivery'}
                  onChange={(e) => setPaymentMethod(e.target.value)}
                  className="h-5 w-5 text-primary border-gray-300 focus:ring-primary"
                />
                <label
                  htmlFor="payOnDelivery"
                  className="ml-3 flex items-center cursor-pointer"
                >
                  <i className="fas fa-truck text-gray-600 text-xl mr-2"></i>
                  <span className="font-medium">Pay on Delivery</span>
                  <span className="ml-2 text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded">
                    Nairobi Only
                  </span>
                </label>
              </div>
            </div>
          </div>

          <div className="mt-8 flex justify-between">
            <button
              type="button"
              onClick={() => navigate('/shipping')}
              className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Back
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-primary text-white rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
            >
              Continue
            </button>
          </div>
        </form>
      </FormContainer>
    </>
  );
};

export default PaymentScreen;
